// extracted by mini-css-extract-plugin
export default {"tabs":"t_b3","tab-list":"t_b4","tab":"t_b5","active":"t_b6"};